// extracted by mini-css-extract-plugin
export default {"main_page":"NewsThree_main_page__pOAOJ","s_box":"NewsThree_s_box__NYfyE"};